/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {TooltipEl} from 'common/components/tooltip';

import type {TrackedUserIcon} from './index';

export function template(this: TrackedUserIcon) {
  const {iconSize} = this.helpers.getIconProperties();
  const avatarSrc = this.helpers.getAvatarSrc();
  return (
    <div sel={`.container${this.attr(`enable-outline`) ? `.outlined` : ``}`}>
      <img
        attrs={{
          elref: `userImg`,
          align: `middle`,
          src: avatarSrc,
        }}
        style={{
          height: `${iconSize}px`,
          width: `${iconSize}px`,
        }}
      />
      {this.helpers.isTooltipEnabled() ? (
        <TooltipEl attrs={{placement: this.attr(`tooltip-placement`)}}>{this.attr(`tooltip-text`)}</TooltipEl>
      ) : null}
    </div>
  );
}
